import {Component, EventEmitter, Input, Output} from '@angular/core';
import {environment} from '@environment';

@Component({
  selector: 'gt-contacts-column-settings',
  templateUrl: './contacts-column-settings.component.html',
  styleUrls: ['./contacts-column-settings.component.scss']
})
export class ContactsColumnSettingsComponent {
  static get ALL_COLUMNS(): Array<string> {
    if (environment.hasDepartments) {
      return ['status', 'name', 'phoneNumber', 'shortNumber', 'email', 'department', 'favourite'];
    } else {
      return ['status', 'name', 'phoneNumber', 'shortNumber', 'email', 'favourite'];
    }
  }
  @Input() displayedColumns: string[] = [];
  @Output() displayedColumnsChanged = new EventEmitter<string[]>();
  @Output() closing = new EventEmitter<void>();
  allColumns = ContactsColumnSettingsComponent.ALL_COLUMNS;
  translationKeys = {
    status: 'contacts.col_status',
    name: 'contacts.col_name',
    phoneNumber: 'contacts.col_number',
    shortNumber: 'contacts.col_short',
    email: 'contacts.col_email',
    department: 'contacts.col_department',
    favourite: 'contacts.col_favorite'
  };

  isDisplayed(column: string): boolean {
    return this.displayedColumns.indexOf(column) > -1;
  }

  columnToggled(column: string, visible: boolean) {
    if (visible) {
      this.displayedColumns.push(column);
    } else {
      this.displayedColumns.splice(this.displayedColumns.indexOf(column), 1);
    }
    this.sortDisplayedColumns();
    this.displayedColumnsChanged.emit(this.displayedColumns);
  }

  sortDisplayedColumns() {
    this.displayedColumns.sort((a, b) => {
      return this.allColumns.indexOf(a) - this.allColumns.indexOf(b);
    });
  }

  closeDialog() {
    this.closing.emit();
  }

  resetSettings() {
    this.displayedColumns = ContactsColumnSettingsComponent.ALL_COLUMNS.slice();
    this.displayedColumnsChanged.emit(this.displayedColumns);
  }

  getTranslationKey(col: string): string {
    return this.translationKeys[col];
  }
}
